module.exports = __webpack_public_path__ + "img/尧山镇.0b5f2bbf.png";